<template>
  <div class="npc-action">
    <character-select
      :selected="state.selectedNpcKey"
      :characters="getNpcCharacters(emitter.caseConf)"
      :disabled="readonly"
      :errors="sourceCharacterErrors"
      placeholder="Select VIP"
      @input="updateNpc"
    />
    <el-select
      v-close-on-zoom
      :value="state.dialogueType"
      :disabled="readonly"
      @input="updateDialogueType"
    >
      <el-option label="Question asked" value="NPC_QUESTION" />
      <el-option label="Command given" value="NPC_COMMAND" />
    </el-select>
    <dialogue-action
      :action-type="state.dialogueType"
      :placeholder="state.dialogueType === 'NPC_COMMAND' ? 'Command' : 'Question'"
      :get-dialogue-items="getSelectedNpcItems"
      :put-data="putDataWithNpcData"
      v-bind="$props"
    />
  </div>
</template>

<script>
import get from 'lodash/get';
import nodeMixins from './mixins/NodeMixins';
import { getNpcCharacters } from '~lib/common/utils/characters';
import CharacterSelect from './CharacterSelect.vue';
import DialogueAction from './DialogueAction.vue';

export default {
  name: 'npc-action',
  components: {
    CharacterSelect,
    DialogueAction,
  },
  mixins: [ nodeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        selectedNpcKey: null,
        dialogueType: null,
      },
    };
  },
  computed: {
    selectedNpc() {
      const npcs = this.emitter.caseConf.npcs || [];
      return npcs.find(npc => npc.key === this.state.selectedNpcKey);
    },
    sourceCharacterErrors() {
      return this.getErrorsById('missingSourceCharacter');
    }
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedNpcKey = get(data, 'npcKey');
    this.state.dialogueType = get(data, 'type') || 'NPC_QUESTION';
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    updateNpc(key) {
      this.state.selectedNpcKey = key;
      // First time selecting an npc we don't want to emit null id and cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithNpcData(this.ikey, {});
    },
    updateDialogueType(type) {
      this.state.dialogueType = type;
      this.putDataWithNpcData(this.ikey, {});
    },
    putDataWithNpcData(key, data) {
      this.putData(key, {
        ...data,
        type: this.state.dialogueType,
        npcKey: this.state.selectedNpcKey,
      });
      this.emitter.trigger('process', this.control);
    },
    getSelectedNpcItems() {
      if (!this.selectedNpc) {
        return [];
      }
      const dialogue = this.selectedNpc.dialogue || {};
      switch (this.state.dialogueType) {
        case 'NPC_COMMAND':
          return dialogue.commands;
        case 'NPC_QUESTION':
          return dialogue.questions;
        default:
          return [];
      }
    },
    getNpcCharacters,
  },
};
</script>

<style scoped>
.npc-action {
  display: flex;
  flex-direction: column;
}
</style>